$(document).ready(function() {

	// naivgation logic
	var lastClicked = "";
	var currentClicked = "";

	$('.nav-trigger').on('click', function(event) {

        currentClicked = $(this).attr('data-trigger');

		//$(this).toggleClass('show');
		// closer acts for every overlay
		var closerActive = $(this).find('.open').is(':visible');

		// close element
		if ((lastClicked == currentClicked && $("nav." + currentClicked).hasClass('active')) || closerActive)  {
			$('body').removeClass('nav-content-active');
			$('nav.active').removeClass('active');
			return;
		}

		if (currentClicked == 'search') {

			setTimeout(function(){
				$("#search_input").focus();
				}, 500);
		}

		// open
		$('nav.active').removeClass('active');
		$('body').addClass('nav-content-active');
        $("nav." + currentClicked).addClass('active');

		lastClicked = currentClicked;
	});

	// // pushpin
	// $('header.main').pushpin({
	// 	top: $('header.main').offset().top,
	// 	bottom: ($('#content').innerHeight()),
	// });

	$('nav .close').on('click', function(event) {
		$('body').removeClass('nav-content-active');
		$('nav.active').removeClass('active');
	});
});



/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/header/index.js
 **/